import React from "react";
import { Navbar, NavItem } from "reactstrap";
import { NavLink, useLocation } from "react-router";
import "./NavMenu.css";
import useNavBar from "../hooks/useNavBar";
import useAuth from "../hooks/useAuth";

export default function ReportNavMenu() {
  const { auth } = useAuth();
  const { loading } = useNavBar();
  const location = useLocation();

  if (loading) return null;

  const base =
    auth.viewLevel === "adminreports"
      ? "/" + location.pathname.split("/")[1]
      : "/myreports/" + location.pathname.split("/")[2];

  const normalizedPath = location.pathname.replace(/\/+$/, "");

  return (
    <header>
      <Navbar
        className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3"
        container
      >
        <ul className="navbar-nav flex-grow">
          <NavItem>
            <NavLink
              to={`${base}/form`}
              className={`nav-link ${normalizedPath === `${base}/form` ? "active" : ""}`}
            >
              Filters
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              to={`${base}/options`}
              className={`nav-link ${normalizedPath === `${base}/options` ? "active" : ""}`}
            >
              View Options
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              to={`${base}/preview`}
              className={`nav-link ${normalizedPath === `${base}/preview` ? "active" : ""}`}
            >
              Preview
            </NavLink>
          </NavItem>
        </ul>
        <div className="nav-link">
          Your data is refreshed in the background every hour.
        </div>
      </Navbar>
    </header>
  );
}
